import { c as _c } from "react/compiler-runtime";
import { FULL_ROUND_LOGOS } from "@/constants/project-specific/tokens";
import { cn } from "@/util/cn";
interface DoubleLogoProps {
  margin?: boolean;
  size?: number;
  logo0?: string;
  logo1?: string;
}
export function DoubleLogo(t0) {
  const $ = _c(14);
  const {
    logo0,
    logo1,
    size: t1,
    margin: t2
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const margin = t2 === undefined ? false : t2;
  let fullRound1 = false;
  if (logo0 && FULL_ROUND_LOGOS.includes(logo0)) {}
  if (logo1 && FULL_ROUND_LOGOS.includes(logo1)) {
    fullRound1 = true;
  }
  const t3 = margin ? "mr-[4px]" : "";
  let t4;
  if ($[0] !== t3) {
    t4 = cn(t3, "flex flex-row");
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== logo0 || $[3] !== logo1 || $[4] !== size) {
    t5 = !logo1 ? <img src={logo0} alt="" className="absolute origin-center z-10 drop-shadow-md" style={{
      borderRadius: "50%",
      width: `${size.toString()}px`,
      height: `${size.toString()}px`,
      marginRight: "4px"
    }} /> : <img src={logo0} alt="" className="absolute origin-center z-10 drop-shadow-md" style={{
      borderRadius: "50%",
      width: `${size.toString()}px`,
      height: `${size.toString()}px`,
      transform: `translateX(${size / 2.5 - 10}px) translateY(${size / 2.5 - 10}px)`,
      marginRight: "4px"
    }} />;
    $[2] = logo0;
    $[3] = logo1;
    $[4] = size;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== fullRound1 || $[7] !== logo1 || $[8] !== size) {
    t6 = logo1 && <img src={logo1} alt="" className={cn(fullRound1 ? "rounded-full" : "", "relative origin-center scale-90 -z-20 drop-shadow-md rounded-full")} style={{
      borderRadius: fullRound1 ? "50%" : "0",
      width: `${(size - 10).toString()}px`,
      height: `${(size - 10).toString()}px`,
      transform: "translateX(-5px) translateY(-5px)"
    }} />;
    $[6] = fullRound1;
    $[7] = logo1;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}